import dotenv from 'dotenv';

let env = {};

if (typeof import.meta !== 'undefined' && import.meta.env) {
  // Vite (frontend)
  env = import.meta.env;
} else if (typeof process !== 'undefined') {
  dotenv.config();
  env = process.env;
}

const Globals = {
  APP_ID: env.VITE_APP_ID || env.APP_ID || 'aka',
  API_URL: env.VITE_API_URL || env.API_URL || (typeof process !== 'undefined' ? `http://localhost:${env.SERVER_PORT || 3001}` : ''),

  EMAIL_DOMAIN: env.VITE_EMAIL_DOMAIN,
  EMAIL_CONTACT: env.VITE_EMAIL_REPORT_BUG,

  APP_NAME: env.VITE_APP_NAME,
  APP_HOME_URL: env.VITE_APP_HOME_URL,
  APP_URL: env.VITE_APP_URL, 
  APP_COLOR: env.VITE_APP_COLOR,
  APP_DESCRIPTOR: env.VITE_APP_DESCRIPTOR,
  APP_NOTE: env.VITE_APP_NOTE,
  APP_FAVICON: env.VITE_APP_FAVICON,
  APP_LOGO_URL: env.VITE_APP_LOGO_URL,
  APP_SPLASH_URL: env.VITE_APP_SPLASH_URL,
  APP_VERSION: env.VITE_APP_VERSION || env.npm_package_version || 'dev',
  APP_LOW_NUMBER_OF_PARTICIPANTS_WARNING: 3,

  APP_ROUTES: {
    HOME: '/',
    CUSTOMER: '/customer',
    ORDER: '/order', 
    AUTH: '/authorization',
    SIGNUP: '/registration',
  },
  

  // RLO, I am not convinced to have to here. this is part of styles
  UI_CONFIG: {
    ROUNDED_CORNERS: {
      LEVEL: 'none', // none | small | medium | large
      CLASSES: {
        none: 'rounded-none',
        small: 'rounded-sm', 
        medium: 'rounded-md',
        large: 'rounded-lg'
      }
    }
  },

  getRoundedClass() {
    return this.UI_CONFIG.ROUNDED_CORNERS.CLASSES[this.UI_CONFIG.ROUNDED_CORNERS.LEVEL];
  }
};


export default Globals;